module.exports = "//cdn-static.kwai.net/kos/s101/nlav11312/incentive-encourage/static/img/share-empty.8716029d.png";